import React, { useState, useContext, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { Link, useNavigate } from "react-router-dom";
import IconLineMockup from 'assets/images/icon_roof_linemockup.svg';
import IconPlus from 'assets/images/icon_circle_plus.svg';
import IconCross from 'assets/images/icon_cross.svg';
import ImageButton from 'components/formElements/ImageButton';
import Compass from 'components/formElements/Compass';
import ActionIcon from 'components/formElements/ActionIcon';
import Label from 'components/formElements/Label';
import InfoBox from 'components/formElements/InfoBox';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';
import { FormContext } from 'context/FormContext';
import MapRoofSelection from 'components/formElements/MapRoofSelection';
import IconTrash from 'assets/images/icon_trash.svg';
import VideoButton from 'assets/images/button_video.png';
import BackgroundMaps from 'assets/images/background_maps.png';
import { useShadowRoot } from 'context/ShadowRootContext';
import defaultValues from 'forms/defaultValues';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const RoofArea = () => {
    const { formValues, setFormValues } = useContext(FormContext);
    const [selectedZone, setSelectedZone] = useState(0);
    const [displayInfobox, setDisplayInfobox] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showRoofSettings, setShowRoofSettings] = useState(false);
    const [formErrors, setFormErrors] = useState([]);
    const handleModalClose = () => setShowModal(false);
    const handleModalShow = () => setShowModal(true);
    const shadowRoot = useShadowRoot();
    const navigate = useNavigate();
    const [skipTriggered, setSkipTriggered] = useState(false);

    const addZone = () => {
        const newValues = { ...formValues };
        newValues.Roof.Zones = [...newValues.Roof.Zones, {
            SquareMeter: 0,
            Points: [],
            Direction: 0,
            Tilt: 0
        }];
        // console.log('Add Roof');
        setFormValues({
            ...formValues,
            Roof: newValues.Roof,
            SkipRoof: false
        });
        setSelectedZone(newValues.Roof.Zones.length - 1);
        setShowRoofSettings(false);
        setFormErrors([]);
    }

    const removeZone = (zindex) => {
        const newValues = { ...formValues };
        newValues.Roof.Zones.splice(zindex, 1)
        setFormValues(newValues);
        setFormErrors([]);
    }

    const setRoofDirection = (e, direction) => {
        const newValues = formValues;
        newValues.Roof.Zones[e.zone].Direction = direction;
        setFormValues({ ...formValues, ...newValues });
        setFormErrors([]);
    }

    const setRoofTilt = (e) => {
        const zone = e.target.dataset.index;
        const newValues = formValues;
        newValues.Roof.Zones[zone].Tilt = parseInt(e.target.value) || 0;
        setFormValues({ ...formValues, ...newValues });
        setFormErrors([]);
    }

    const FloatingButton = (props) => {
        return (
            <div className={`FloatingButton cursor-pointer ${props.visible ? 'visible' : ''}`} onClick={props.onClick}>
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 0C6.03 0 0 6.03 0 13.5C0 20.97 6.03 27 13.5 27C20.97 27 27 20.97 27 13.5C27 6.03 20.97 0 13.5 0ZM15 19.77C15 20.5801 14.3101 21.2401 13.5 21.2401C12.6899 21.2401 12 20.5801 12 19.77V12.09C12 11.2799 12.6899 10.6199 13.5 10.6199C14.3101 10.6199 15 11.2799 15 12.09V19.77ZM13.5299 8.7C12.7199 8.7 12.0599 8.04 12.0599 7.22995C12.0599 6.41989 12.7199 5.75989 13.5299 5.75989C14.34 5.75989 15 6.41989 15 7.22995C15 8.04 14.34 8.7 13.5299 8.7Z" fill="#5CC244" /></svg>
            </div>
        )
    }

    const MobileButtonAddRoof = () => (<svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32.5" cy="32.5" r="32.5" fill="#333D46" />
        <g clip-path="url(#clip0_1249_178)">
            <path d="M32 45C29.4288 45 26.9154 44.2376 24.7776 42.8091C22.6398 41.3807 20.9735 39.3503 19.9896 36.9749C19.0056 34.5995 18.7482 31.9856 19.2498 29.4638C19.7514 26.9421 20.9895 24.6257 22.8076 22.8076C24.6257 20.9895 26.9421 19.7514 29.4638 19.2498C31.9856 18.7482 34.5995 19.0056 36.9749 19.9896C39.3503 20.9735 41.3807 22.6398 42.8091 24.7776C44.2376 26.9154 45 29.4288 45 32C45 35.4478 43.6304 38.7544 41.1924 41.1924C38.7544 43.6304 35.4478 45 32 45V45ZM32 21C29.8244 21 27.6977 21.6451 25.8887 22.8538C24.0798 24.0625 22.6699 25.7805 21.8373 27.7905C21.0048 29.8005 20.7869 32.0122 21.2114 34.146C21.6358 36.2798 22.6835 38.2398 24.2218 39.7782C25.7602 41.3166 27.7202 42.3642 29.854 42.7886C31.9878 43.2131 34.1995 42.9952 36.2095 42.1627C38.2195 41.3301 39.9375 39.9202 41.1462 38.1113C42.3549 36.3023 43 34.1756 43 32C43 29.0826 41.8411 26.2847 39.7782 24.2218C37.7153 22.1589 34.9174 21 32 21Z" fill="white" />
            <path d="M32 39C31.7348 39 31.4804 38.8946 31.2929 38.7071C31.1054 38.5196 31 38.2652 31 38V26C31 25.7348 31.1054 25.4804 31.2929 25.2929C31.4804 25.1054 31.7348 25 32 25C32.2652 25 32.5196 25.1054 32.7071 25.2929C32.8946 25.4804 33 25.7348 33 26V38C33 38.2652 32.8946 38.5196 32.7071 38.7071C32.5196 38.8946 32.2652 39 32 39Z" fill="white" />
            <path d="M38 33H26C25.7348 33 25.4804 32.8946 25.2929 32.7071C25.1054 32.5196 25 32.2652 25 32C25 31.7348 25.1054 31.4804 25.2929 31.2929C25.4804 31.1054 25.7348 31 26 31H38C38.2652 31 38.5196 31.1054 38.7071 31.2929C38.8946 31.4804 39 31.7348 39 32C39 32.2652 38.8946 32.5196 38.7071 32.7071C38.5196 32.8946 38.2652 33 38 33Z" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_1249_178">
                <rect width="32" height="32" fill="white" transform="translate(16 16)" />
            </clipPath>
        </defs>
    </svg>
    );

    const DynamicToast = (props) => {
        const [show, setShow] = useState(true);

        return (
            <Toast onClose={() => setShow(false)} show={show} delay={3000} bg="danger" autohide>
                <Toast.Body>{props.children}</Toast.Body>
            </Toast>
        );
    }

    const getTotalSquareMeterUsable = () => {
        return formValues.Roof.Zones.reduce((sum, zone) => sum + (zone.SquareMeterUsable || 0), 0);
    };

    const handleFormCheck = (e) => {
        let checkHasFailed = false;
        let errorMessages = [];

        if (formValues.Roof.Zones.length === 0) {
            errorMessages.push('Wählen Sie mindestens eine Dachfläche aus');
            checkHasFailed = true;
        } else {
            formValues.Roof.Zones.map((zone, index) => {
                if (!zone.hasOwnProperty('Points') || zone.Points.length === 0 || zone.Points.length < 3) {
                    errorMessages.push(`Dachfläche ${index + 1} ist unvollständig.`);
                    checkHasFailed = true;
                }
                // console.log('zone.Tilt', zone.Tilt);
                if (zone.Tilt <= 1) {
                    errorMessages.push(`Dachneigung ${index + 1} muss größer als 1° sein.`);
                    checkHasFailed = true;
                }
            });

            if (getTotalSquareMeterUsable() == 0) {
                errorMessages.push(`Die benutzbare Fläche muss größer als 0 sein.`);
                checkHasFailed = true;
            }
        }

        if (checkHasFailed === true) {
            e.preventDefault();
            setFormErrors(errorMessages);
            // console.log(errorMessages)
        }

        setFormValues(prev => ({
            ...prev,
            SkipRoof: false
        }));
    }

    useEffect(() => {
        if (skipTriggered && formValues.SkipRoof === true) {
            // Statemanagement is such a mess that we have to do this here unfortunately ....
            // maybe create a extra function and remember to always store formValues, when neccessary, before navigating
            localStorage.setItem('formValues', JSON.stringify(formValues));
            navigate('/EnergyConsumption');
        }
    }, [formValues.SkipRoof, skipTriggered]);

    const handleSkipRoof = () => {
        setSkipTriggered(true);
        setFormValues(prev => ({
            ...prev,
            SkipRoof: true,
            Roof: defaultValues.Roof
        }));
    };

    const mapBackgroundStyle = {
        background: `url(${BackgroundMaps}) no-repeat`,
        backgroundSize: 'cover'
    };

    const handleZoneClick = (zindex) => {
        setSelectedZone(zindex);
        setShowRoofSettings(false);
        setFormErrors([]);
    }

    const renderTooltip = (props) => (
        <Tooltip {...props} container={shadowRoot}>Überspringe die Dachkonfiguration. Achtung: Die Dachfläche ist zur Errechnung der möglichen PV Module und Ihres Ertrags zwingend notwendig!</Tooltip>
    );

    return (
        <Row className="full-height">
            <Col className="">
                <div className="ContainerPaddingSmall">
                    <div className={`roofSettings ${showRoofSettings ? 'active' : ''}`}>
                        <Stack gap={3}>
                            <h1 className="mb-0">Ihr Dach</h1>
                            <div>Markieren Sie mindestens 4 Punkte auf der Abbildung, um Ihre Dachfläche hinzuzufügen. Definieren Sie Dachausrichtung und Dachneigung.</div>
                            {formValues.Roof.Zones.map((zone, zindex) => (
                                <React.Fragment key={zindex}>
                                    <Stack gap={3} direction="horizontal" className="justify-content-around align-items-start flex-wrap">
                                        <div>
                                            <Label text={"Dachfläche " + (zindex + 1)} />
                                            <ImageButton label={formValues.Roof.Zones[zindex].SquareMeter.toFixed(2) + " m²"} className={zindex === selectedZone ? 'active mt-2' : 'mt-2'} image={IconLineMockup} onClick={() => handleZoneClick(zindex)}>
                                                <ActionIcon image={IconTrash} data-index={zindex} onClick={e => { e.preventDefault(); e.stopPropagation(); removeZone(zindex) }} />
                                            </ImageButton>
                                        </div>
                                        <div>
                                            <Label text="Dachausrichtung" />
                                            <Compass className="active mt-2" zone={zindex} onClick={setRoofDirection} defaultDirection={formValues.Roof.Zones[zindex].Direction} />
                                        </div>
                                        <div>
                                            <Label text="Dachneigung" />
                                            <InputGroup className="mb-3 shortInput mt-2">
                                                <Form.Control onChange={setRoofTilt} data-index={zindex} defaultValue={formValues.Roof.Zones[zindex].Tilt ?? 0} />
                                                <InputGroup.Text>Grad</InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                    </Stack>
                                    <hr />
                                </React.Fragment>
                            ))}

                            <ImageButton label="Dachfläche hinzufügen" image={IconPlus} onClick={addZone} />
                        </Stack>
                        <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                            <Link className={`order-2 order-md-0 btn-previous`} to="/RoofType"><Button variant="outline-light">Zurück</Button></Link>
                            <Link className={`order-0 order-md-1 btn-next ${showRoofSettings ? '' : 'hide-mobile'}`} to="/RoofObstacles" onClick={handleFormCheck}><Button variant="success">Weiter zum nächsten Schritt</Button></Link>
                            {/* <OverlayTrigger container={shadowRoot} placement="top" overlay={renderTooltip}>
                                <Button className={`order-1 order-md-2 ${showRoofSettings ? '' : 'hide-mobile'}`} onClick={handleSkipRoof} variant="success">Überspringen</Button>
                            </OverlayTrigger> */}
                        </Stack>
                        {formErrors.length > 0 &&
                            <ToastContainer className="position-absolute" position="middle-center">
                                <DynamicToast>
                                    {formErrors.map((error, index) => (
                                        <div key={index}>{error}</div>
                                    ))}
                                </DynamicToast>
                            </ToastContainer>
                        }
                    </div>
                </div>
            </Col>
            <Col className="backgroundMaps mapContainerWrapper" onClick={e => setFormErrors([])} style={mapBackgroundStyle}>
                <MapRoofSelection selectedZone={selectedZone} />
                <InfoBox absolute hidden={displayInfobox}>
                    <div className="d-flex">
                        <div>Bitte markieren Sie mindestens 3 Punkte auf der Abbildung, um Ihre Dachfläche hinzuzufügen.</div>                       
                    </div>
                </InfoBox>
                <FloatingButton visible={displayInfobox} onClick={e => setDisplayInfobox(false)} />
            </Col>

            { /* TODO Cleanup */}
            { !showRoofSettings &&             
                <div className="mobileControls d-flex flex-row">
                    <div className="align-items-center justify-content-center me-3">                    
                        <ImageButton 
                            disabled={!(formValues.Roof.Zones.length && formValues.Roof.Zones[selectedZone] && formValues.Roof.Zones[selectedZone].hasOwnProperty('Points') && (formValues.Roof.Zones[selectedZone].Points.length > 2 || formValues.Roof.Zones[selectedZone].Points.length === 0))}
                            label="Dachfläche hinzufügen" image={IconPlus} onClick={addZone} />                                    
                    </div>
                    <Row className="mobileControlsRightPanel align-items-center justify-content-center">                                          
                        <Col xs={8} className="text-center">
                            <div>{"Dachfläche " + (selectedZone + 1) + " markieren"}</div>
                        </Col>
                        <Col xs={4} className="d-flex justify-content-end" onClick={e => {
                            if (formValues.Roof.Zones.length && formValues.Roof.Zones[selectedZone] && formValues.Roof.Zones[selectedZone].hasOwnProperty('Points') && (formValues.Roof.Zones[selectedZone].Points.length > 2 || formValues.Roof.Zones[selectedZone].Points.length === 0)) {
                                setShowRoofSettings(true)
                            }
                        }}><svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="32.5" cy="32.5" r="32.5" fill={formValues.Roof.Zones.length && formValues.Roof.Zones[selectedZone] && formValues.Roof.Zones[selectedZone].hasOwnProperty('Points') && (formValues.Roof.Zones[selectedZone].Points.length > 2 || formValues.Roof.Zones[selectedZone].Points.length === 0) ? "rgb(92, 194, 68)" : "#333D46"} />
                                <path d="M18 34.363L20.9408 37.2L26.2164 42L46 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Col>
                    </Row>
                </div>            
            }

            <Modal
                container={shadowRoot}
                show={showModal}
                onHide={handleModalClose}
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/G1bkZ02W3Jw?si=MUP7hWEsxwvz10Lf" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                </Modal.Body>
            </Modal>
        </Row>
    )
}

export default RoofArea;